import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { IMODALS_SERVICE, IModalsService, INOTIFICATIONS_SERVICE, INotificationsService } from '@platform500services/p500-ui-kit';
import { forkJoin } from 'rxjs';
import { QuestionActionConfig } from '../../action-configs/questions/question.action-config';
import { ICRMQuestionData } from '../../components/form-fields/questions/questions.component';
import { ActionsServiceInterface } from '../../services/actions/actions-service.interface';
import { IDataService } from '../../services/data/data-service.interface';
import { PageServiceInterface } from '../../services/page/page-service.interface';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';
import { ActionFormModal } from '../action-form/action-form.modal';
import { AuthServiceInterface } from '../../services/auth/auth-service.interface';
import { Router } from '@angular/router';

@Component({
  templateUrl: '../action-form/action-form.modal.html',
})
export class QuestionsModal extends ActionFormModal implements OnInit {
  constructor(
    @Inject(IMODALS_SERVICE) modalsService: IModalsService,
    @Inject('ActionsServiceInterface') actionsService: ActionsServiceInterface,
    @Inject(INOTIFICATIONS_SERVICE) notificationsService: INotificationsService,
    @Inject('PageServiceInterface') pageService: PageServiceInterface,
    cd: ChangeDetectorRef,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('RbacServiceInterface') private rbacService: RbacServiceInterface,
    @Inject('AuthServiceInterface') authService: AuthServiceInterface,
    router: Router
  ) {
    super(modalsService, actionsService, notificationsService, pageService, cd, authService, router);
  }
  public items: ICRMQuestionData[];

  public ngOnInit(): void {
    this.data = {
      id: undefined,
      repository: {},
      config: () => new QuestionActionConfig(this.dataService, this.rbacService, this.items),
    };
  }

  public submit(): void {
    this.isLoading = true;
    const makeRequest = (question_id: number, answer: any, id: number) =>
      this.actionsService.process(this.config, { question_id, answer }, id, {});
    const body = this.form.getRawValue().answer;
    const idMap = this.items.reduce((acc, item) => (acc.set(item.question_id, item.answer_id), acc), new Map());
    forkJoin(body.map((item) => makeRequest(item.question_id, item.answer, idMap.get(item.question_id)))).subscribe(
      () => {
        this.close();
        this.pageService.refresh();
        this.isLoading = false;
        this.notificationsService.add(
          {
            type: 'success',
            title: 'Success',
          },
          true
        );
      },
      () => (this.isLoading = false)
    );
  }
}
